h<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <v-card-title>
            <h3>Detail Data Ruangan</h3>
          </v-card-title>
          <v-card-text>
            <table style="border-collapse: collapse; width: 80%;">
              <tr>
                <td><strong>Gedung</strong></td>
                <td>{{form.idGedung.nama}}</td>
              </tr>
              <tr>
                <td><strong>Lokasi</strong></td>
                <td>{{form.idGedung.idLokasi.nama}}</td>
              </tr>
              <tr>
                <td><strong>Kode Ruangan</strong></td>
                <td>{{form.kodeRuangan}}</td>
              </tr>
              <tr>
                <td><strong>Nama Ruangan</strong></td>
                <td>{{form.namaRuangan}}</td>
              </tr>
              <tr>
                <td><strong>Lantai</strong></td>
                <td>1</td>
              </tr>
              <tr>
                <td><strong>Kapasitas</strong></td>
                <td>{{form.kapasitasMaksimal}}</td>
              </tr>
              <tr>
                <td><strong>Multiple Class</strong></td>
                <td>{{dataMultiple(form.isMultipleClassAllowed)}}</td>
              </tr>
              <tr>
                <td><strong>Jenis Ruangan</strong></td>
                <td>{{form.idJenisRuangan.nama}}</td>
              </tr>
              <tr>
                <td><strong>Kondisi Ruangan</strong></td>
                <td>{{form.idStatusAset.nama}}</td>
              </tr>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              style="width:120px;"
              color="blue"
              @click="onUpdate">
              <v-icon left>
                fa fa-save
              </v-icon>
              Ubah Data
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-card-title>
            <h3>History Peminjaman Ruangan</h3>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="items" item-key="id" class="elevation-1">
              <template slot="items" slot-scope="props">
                <td>{{props.item.mulai}}</td>
                <td>{{props.item.selesai}}</td>
                <td>{{ props.item.namaPIC }}</td>
                <td>{{ props.item.jenisPenggunaanRuangan }}</td>
                <td>{{props.item.statusPenggunaanRuangan}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <br>
        <v-btn  small depressed color="red" @click="onBatal">
          <i class="fa fa-times" aria-hidden="true" />
          <span style="padding:8px;color:white">
                  <strong>Kembali</strong>
                </span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {base} from "../../setup-axios"
  import {createJWT} from "../../store/module/helper";

  export default {
      name: "View",
      data() {
        return {
          form : {},
          multiple : [
            {
              text : "Ya",
              value : true
            },
            {
              text : "Tidak",
              value : false
            }
          ],
          items: [],
          headers: [
            {
              text: "Tanggal Mulai Peminjaman",
              value: "mulai"
            },
            {
              text: "Tanggal Akhir Peminjaman",
              value: "selesai"
            },
            {
              text: "Nama PIC",
              value: "usernamePengaju"
            },
            {
              text: "Jenis Peminjaman",
              value: "deskripsi"
            },
            {
              text: "Status",
              value: ""
            }
          ],
        }
      },

      created() {
        base.get("ruangan/" + this.$route.params.id ,
          {
            headers: {
              'Authorization' : createJWT()
            }
          }).then((resp) => {
          this.form = resp.data.resultById
        })

        base.get("penggunaanRuangan/history/" + this.$route.params.id,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
        ).then((resp) => {
          this.items = resp.data.result
        })
      },
      methods : {
        onBatal() {
          localStorage.setItem("flag", false)
          this.$router.push("/ruangan/ruangan")
        },

        onUpdate(){
          this.$router.push("/ruangan/edit/" + this.$route.params.id)
        },

        dataMultiple(data){
          if(data){
            return 'Ya'
          }

          else {
            return 'Tidak'
          }
        },

        tanggalParse(value){
          return value.substring(0,10)
        },
      }
    }
</script>

<style scoped>
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
</style>